<template>
    <svg
        width="48"
        height="48"
        viewBox="0 0 48 48"
        fill="none"
        :style="{ backgroundColor }"
        xmlns="http://www.w3.org/2000/svg">
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M22.5799 11.7916C23.241 12.5665 24.4897 12.7555 25.665 12.661C26.2894 12.6232 25.5548 7.99277 25.2243 5.6303C25.0957 4.68531 25.2426 3.55132 24.5632 2.81422C24.1959 2.41733 23.241 1.58574 22.5982 2.24723C22.3411 2.53073 22.3044 2.71973 22.2493 2.88982C21.6984 4.60971 22.1759 6.65089 22.3779 8.46527C22.488 9.42916 21.9188 11.0923 22.5799 11.7916Z"
            fill="currentColor" />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M30.3844 14.7777C30.5864 15.4392 31.174 16.5543 31.5597 16.7055C32.4779 17.0646 33.8369 15.5904 34.4796 15.099C35.2509 14.4942 36.114 14.0028 36.9037 13.4169C38.9788 11.8671 41.4764 9.22115 40.2092 7.89817C37.6199 7.14217 35.0856 9.82595 32.7534 11.7348C32.1474 12.2262 29.8335 13.7004 30.3109 14.6643L30.3844 14.7777Z"
            fill="currentColor" />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M35.547 23.7739C35.6205 23.6983 35.6939 23.6416 35.8592 23.5849C37.6222 22.8478 41.1481 24.4354 42.6172 24.9268C43.5905 25.2481 45.7391 25.4371 45.9595 26.1364C46.2166 26.9113 45.1882 27.4027 44.674 27.535C42.654 28.0831 39.5688 27.0247 37.6405 26.3821C36.4652 25.9852 34.9594 25.3993 35.4552 23.8873C35.4919 23.8873 35.5287 23.7928 35.547 23.7739Z"
            fill="currentColor" />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M2.12244 22.1111C3.31612 20.2212 7.92553 21.9977 9.67013 22.4135C10.2027 22.5458 12.939 22.5647 13.2144 23.3963C13.5083 24.3224 12.4615 25.0784 11.9289 25.343C9.83541 26.3258 6.52985 25.4564 4.49142 24.9272C3.22429 24.6059 1.60824 24.209 2.08571 22.1678L2.12244 22.1111Z"
            fill="currentColor" />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M16.2463 31.8063C14.5752 31.3149 12.9775 32.6946 11.6553 33.6018C10.4249 34.4712 9.24956 35.0949 8.29462 36.3233C7.52333 37.2872 5.15435 40.538 8.16608 40.1033C10.8656 39.7253 12.3531 37.4384 14.2446 35.7374C15.0343 35.0193 17.44 33.2049 16.3381 31.863C16.3381 31.863 16.3014 31.8063 16.2463 31.8063Z"
            fill="currentColor" />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M25.7025 36.0584C25.6842 38.5153 25.7576 40.6699 25.023 43.0891C24.8394 43.6939 24.5456 44.8846 23.7559 45.0925C22.1949 45.5083 21.9746 42.8623 21.9011 41.974C21.7542 39.8383 21.5889 37.1734 22.7826 35.189C23.811 33.488 25.9045 33.9227 25.6841 35.9828L25.7025 36.0584Z"
            fill="currentColor" />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M12.9924 14.4566C14.0575 15.5717 16.1694 18.4256 17.1795 15.9119C17.8589 14.2298 16.9224 13.2849 15.8205 12.132C14.8839 11.1492 14.2045 10.0341 13.1761 9.108C12.0926 8.14411 9.39304 6.27303 9.22776 9.3159C9.11758 11.3571 11.9273 12.7179 12.8822 14.2865L12.9924 14.4566Z"
            fill="currentColor" />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M36.0214 33.8092C34.7726 32.9209 32.3118 30.5962 31.7609 33.2422C31.3936 35.0188 32.4955 35.7937 33.7626 36.7009C34.8645 37.4758 35.7092 38.4585 36.9029 39.1767C38.1333 39.9327 41.1267 41.2557 40.741 38.2318C40.4839 36.1906 37.4171 35.4346 36.2418 34.036L36.0214 33.8092Z"
            fill="currentColor" />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M29.3732 30.0487C29.8139 30.0487 29.8874 26.609 29.7588 25.3049C29.667 24.3032 30.1812 23.207 29.5568 22.262C29.2446 21.7895 28.7488 21.506 28.2897 21.1091C27.6653 20.561 26.7838 19.7862 26.1411 19.2192C25.3698 18.5199 24.2496 17.0457 23.8272 17.0457C23.3681 17.0457 21.7153 19.6161 20.9807 20.4476C20.0809 21.4871 18.979 22.6967 19.0341 23.4905C19.1443 25.3049 19.0341 26.2499 19.0341 27.8753C19.0341 28.1966 18.8688 30.1243 20.3563 30.0676L29.3732 30.0487Z"
            fill="currentColor" />
    </svg>
</template>

<script lang="ts">
    import { defineComponent } from 'vue';

    export default defineComponent({
        props: {
            backgroundColor: {
                type: String,
                required: true,
            },
        },
    });
</script>
